<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="hse.hse_type_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/hse`">
                            <i class="fa fa-shield"></i> Management Involvement & Commitment
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ hse.hse_type_name }} on {{ hse.hse_date_formatted }} for {{ hse.FirstName + ' ' + hse.LastName  }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>MIC: {{ hse.hse_type_name }}</strong>
                            <div class="pull-right">
                                <router-link :to="`/hse/edit/${hse.hse_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">MIC Type</div>
                                <div class="col-md-8">{{ hse.hse_type_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">MIC Date</div>
                                <div class="col-md-8">{{ hse.hse_date_formatted }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Employee</div>
                                <div class="col-md-8">
                                    <router-link :to="`/employees/view/${hse.employee_id}`" title="View Employee">{{ hse.FirstName }} {{ hse.LastName }} - {{ hse.EmployeeNumber }}</router-link>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Jobsite:</div>
                                <div class="col-md-8">
                                    <router-link :to="`/jobsites/view/${hse.JobsiteId}`" v-if="hse.JobsiteId">
                                        {{ hse.JobsiteNumber }} - {{ hse.JobsiteName }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Division:</div>
                                <div class="col-md-8">
                                    {{ hse.division_code }} - {{ hse.DivisionName }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Files &amp; Photos</strong>
                        </div>
                        <div class="card-body">
                            <file-list :files="files" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                hse_id: this.$route.params.id,
                hse: {},
                files: [],
            }
        },

        methods: {

            getHse: function() {
                //Get the data
                this.$http
                    .get('hse/view/' + this.hse_id)
                    .then(response => {
                        //Set all the data
                        this.hse = response.data.hse;
                        this.files = response.data.files;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

        },
        mounted() {
            //Get the MIC
            this.getHse();
        }
    }
</script>
